<p-accordion [multiple]="true">
    <p-accordionTab [selected]="true" header="Payroll Items">
        <div class="mb-2" *ngIf="qbo && !externalIntegration">
            <p-checkbox
                [binary]="true"
                [ngModel]="showInactive"
                (ngModelChange)="showInactiveChange.emit($event)"
                inputId="showInactivePayrollItems"
            ></p-checkbox>
            <label for="showInactivePayrollItems" class="ml-2">Show inactive</label>
        </div>
        <div
            [ngStyle]="{
                'max-height.vh': 50
            }"
            id="divPayroll"
        >
            <div class="table-container">
                <p-table stripedRows #dataTable
                    [value]="payrollItems"
                    tableStyleClass="table p-datatable-full"
                    dataKey="PIListID"
                    editMode="row"
                    [(selection)]="selected"
                    [style]="{ 'min-width': '70em' }"
                    selectionMode="single"
                    (onRowSelect)="onRowSelect($event)"
                    [scrollable]="true"
                    [scrollHeight]="'40vh'"
                    [virtualScroll]="true"
                    [virtualRowHeight]="27"
                >
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="12" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template #header let-item>
                        <tr>
                            <!-- Edit -->
                            <th class="edit-cell"></th>
                            <!-- Status-->
                            <th class="status-cell">
                                <i
                                    class="pi pi-exclamation-circle"
                                    title="Status"
                                ></i>
                            </th>
                            <!-- Payroll Item-->
                            <th


                            >
                                Payroll Item
                                <p-sortIcon
                                    pSortableColumn="PayrollItem"
                                    field="PayrollItem"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                                <p-columnFilter field="PIListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect
                                            defaultLabel="Filter"
                                            maxSelectedLabels="1"
                                            appendTo="body"
                                            [options]="payrollItemsSelectItems"
                                            [filter]="true"
                                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                                        ></p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Payroll Type-->
                            <th


                            >
                                Payroll Item Type
                                <p-sortIcon
                                    pSortableColumn="PayrollItemType"
                                    field="PayrollItemType"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                                <p-columnFilter field="PayrollItemType" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect
                                            defaultLabel="Filter"
                                            maxSelectedLabels="1"
                                            appendTo="body"
                                            [options]="payrollItemTypesSelectItems"
                                            [filter]="true"
                                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                                        ></p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Payroll Item Display-->
                            <th


                            >
                                Payroll Item Display
                                <p-sortIcon
                                    pSortableColumn="PayrollDisplay"
                                    field="PayrollDisplay"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                                <p-columnFilter type="text" matchMode="contains" field="PayrollDisplay" display="menu" class="ml-auto" />
                            </th>
                            <!-- Account-->
                            <th


                            >
                                Account
                                <p-sortIcon
                                    pSortableColumn="AccountName"
                                    field="AccountName"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                                <p-columnFilter type="text" matchMode="contains" field="AccountName" display="menu" class="ml-auto" />
                            </th>
                            <!-- Labor Type -->
                            <th


                            >
                                Labor Type
                                <p-sortIcon
                                    pSortableColumn="LaborType"
                                    field="LaborType"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                                <p-columnFilter field="LaborType" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect
                                            defaultLabel="Filter"
                                            maxSelectedLabels="1"
                                            appendTo="body"
                                            [options]="laborSelectItems"
                                            [filter]="true"
                                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                                        ></p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- Leave Request PI-->
                            <th


                            >
                                Leave
                                <p-sortIcon
                                    pSortableColumn="IsLeaveRequestPI"
                                    field="IsLeaveRequestPI.toString()"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </th>
                            <!-- Sick PI-->
                            <th


                            >
                                Sick
                                <p-sortIcon
                                    pSortableColumn="IsSickPI"
                                    field="IsSickPI.toString()"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </th>
                            <!-- Holiday PI-->
                            <th>
                                Holiday
                                <p-sortIcon
                                    pSortableColumn="IsHolidayPI"
                                    field="IsHolidayPI.toString()"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </th>
                            <!-- IsActive (QBO only, excludes GovConPay) -->
                            <!-- *ngIf="qbo && !externalIntegration" -->
                            <th
                                *featureFlag="'ffInactivatePayrollItems'"
                            >
                                Is Active
                                <p-sortIcon
                                    pSortableColumn="IsActive"
                                    field="IsActive.toString()"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </th>
                            <th>
                                Alt Pay Rate
                                <p-sortIcon
                                    pSortableColumn="IsAlternateHourly"
                                    field="IsAlternateHourly.toString()"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </th>                            
                            <!-- Export Code -->
                            <th
                                *ngIf="qbo"


                            >
                                Export Code
                                <p-sortIcon
                                    pSortableColumn="ExportCode"
                                    field="ExportCode"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                ></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template
                        #body
                        let-item
                        let-edit="editing"
                        let-ri="rowIndex"
                        let-rowData
                    >
                        <tr
                            [pSelectableRow]="item"
                            [pEditableRow]="item"
                            data-id="row-{{ item.PIListID }}"
                            [ngClass]="{
                                'ui-editing-row':
                                    edit && editing?.id === rowData?.id
                            }"
                        >
                            <!-- Edit -->
                            <td class="edit-cell">

                                    <button
                                        title="Add"
                                        *ngIf="item?.id === 'add' && !edit"
                                        pButton
                                        type="button"
                                        pInitEditableRow
                                        icon="pi pi-plus"
                                        class="p-button-rounded p-button-text p-button-success"
                                        (click)="onRowEditInit(item)"
                                    ></button>
                                    <button
                                        title="Edit"
                                        *ngIf="
                                            !edit &&
                                            (!editing?.id ||
                                                editing?.id === item?.id) &&
                                            item?.id !== 'add'
                                        "
                                        pButton
                                        type="button"
                                        pInitEditableRow
                                        icon="pi pi-pencil"
                                        class="p-button-rounded p-button-text"
                                        (click)="onRowEditInit(item)"
                                        title="Edit"
                                    ></button>
                                    <button
                                        *ngIf="edit"
                                        pButton
                                        type="button"
                                        pSaveEditableRow
                                        icon="pi pi-check"
                                        class="p-button-rounded p-button-text p-button-success"
                                        (click)="onRowEditSave(item)"
                                    ></button>
                                    <button
                                        *ngIf="edit"
                                        pButton
                                        type="button"
                                        pCancelEditableRow
                                        icon="pi pi-times"
                                        class="p-button-rounded p-button-text p-button-danger"
                                        (click)="onRowEditCancel(item)"
                                    ></button>

                            </td>
                            <!-- Status-->
                            <td class="status-cell">
                                <div
                                    (click)="onStatusClick(item)"
                                    class="status-cell"
                                >
                                    <ef-status-icon
                                        [status]="item?.Status?.StatusCode"
                                        [message]="item?.Status?.Message"
                                    ></ef-status-icon>
                                </div>
                            </td>

                            <!-- Payroll Item-->
                            <td class="disabled">
                                <p-cellEditor>
                                    <ng-template
                                        *ngIf="!item.IsReadOnly && qbo && !externalIntegration"
                                        pTemplate="input"
                                    >
                                        <input
                                            required
                                            pInputText
                                            [(ngModel)]="item.PayrollItem"
                                        />
                                    </ng-template>
                                    <ng-template
                                        *ngIf="item.IsReadOnly || !qbo || externalIntegration"
                                        pTemplate="input"
                                    >
                                        {{ item?.PayrollItem }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ item?.PayrollItem }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Payroll Item Type -->
                            <td class="disabled">
                                <p-cellEditor>
                                    <ng-template
                                        *ngIf="!item.IsReadOnly && qbo && !externalIntegration"
                                        pTemplate="input"
                                    >
                                        <p-select
                                            [style]="{ width: '100%' }"
                                            [virtualScroll]="true"
                                            [itemSize]="dropdownItemHeight"
                                            [required]="true"
                                            [options]="
                                                payrollItemTypesSelectItems
                                                    | orderBy: 'label'
                                            "
                                            [autoDisplayFirst]="false"
                                            appendTo="body"
                                            [(ngModel)]="item.PayrollItemType"
                                            (ngModelChange)="onPayrollItemTypeChange(item)"
                                            defaultLabel="Labor Type"
                                            [filter]="true"
                                        ></p-select>
                                    </ng-template>
                                    <ng-template
                                        *ngIf="item.IsReadOnly || !qbo || externalIntegration"
                                        pTemplate="input"
                                    >
                                        {{ item.PayrollItemType }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                            (
                                                payrollItemTypesSelectItems
                                                | itemlookup
                                                    : 'value'
                                                    : item.PayrollItemType
                                            )?.label
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Payroll Item Display-->
                            <td>
                                <p-cellEditor>
                                    <ng-template
                                        *ngIf="!item.IsReadOnly"
                                        pTemplate="input"
                                    >
                                        <input
                                            pInputText
                                            [(ngModel)]="item.PayrollDisplay"
                                        />
                                    </ng-template>
                                    <ng-template
                                        *ngIf="item.IsReadOnly"
                                        pTemplate="input"
                                    >
                                        {{ item?.PayrollDisplay }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ item?.PayrollDisplay }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Account Name-->
                            <td class="disabled">
                                <p-cellEditor>
                                    <ng-template
                                        *ngIf="
                                            !item.IsReadOnly &&
                                            (qbo || externalIntegration)
                                        "
                                        pTemplate="input"
                                    >
                                        <p-select
                                            required
                                            [style]="{ width: '100%' }"
                                            [virtualScroll]="true"
                                            [itemSize]="dropdownItemHeight"
                                            [options]="
                                                accountSelectItems
                                                    | orderBy: 'label'
                                            "
                                            [autoDisplayFirst]="false"
                                            appendTo="body"
                                            [(ngModel)]="item.AccountListID"
                                            defaultLabel="Account"
                                            [filter]="true"
                                        ></p-select>
                                    </ng-template>
                                    <ng-template
                                        *ngIf="
                                            item.IsReadOnly ||
                                            !(qbo || externalIntegration)
                                        "
                                        pTemplate="input"
                                    >
                                        {{ item?.AccountName }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ item?.AccountName }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Labor Type -->
                            <td>
                                <p-cellEditor>
                                    <ng-template
                                        *ngIf="!item.IsReadOnly"
                                        pTemplate="input"
                                    >
                                        <p-select
                                            [style]="{ width: '100%' }"
                                            [virtualScroll]="true"
                                            [itemSize]="dropdownItemHeight"
                                            [options]="
                                                laborSelectItems
                                                    | orderBy: 'label'
                                            "
                                            [autoDisplayFirst]="false"
                                            appendTo="body"
                                            [(ngModel)]="item.LaborType"
                                            defaultLabel="Labor Type"
                                            [filter]="true"
                                        ></p-select>
                                    </ng-template>
                                    <ng-template
                                        *ngIf="item.IsReadOnly"
                                        pTemplate="input"
                                    >
                                        {{
                                            (
                                                laborTypes
                                                | itemlookup
                                                    : 'CalcType'
                                                    : item?.LaborType
                                            )?.CalcDesc
                                        }}
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{
                                            (
                                                laborTypes
                                                | itemlookup
                                                    : 'CalcType'
                                                    : item?.LaborType
                                            )?.CalcDesc
                                        }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- Leave Request PI-->
                            <td class="checkbox">
                                <div *ngIf="item.LaborType !== 'FRL'"></div>
                                <div *ngIf="item.LaborType === 'FRL'">
                                    <p-cellEditor>
                                        <ng-template
                                            *ngIf="!item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <p-checkbox
                                                [disabled]="
                                                    item.IsReadOnly ||
                                                    item.LaborType !== 'FRL'
                                                "
                                                binary="true"
                                                type="checkbox"
                                                [(ngModel)]="
                                                    item.IsLeaveRequestPI
                                                "
                                            ></p-checkbox>
                                        </ng-template>
                                        <ng-template
                                            *ngIf="item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check':
                                                        item?.IsLeaveRequestPI,
                                                    green: item?.IsLeaveRequestPI
                                                }"
                                            ></i>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check':
                                                        item?.IsLeaveRequestPI,
                                                    green: item?.IsLeaveRequestPI
                                                }"
                                            ></i>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </td>
                            <!-- Sick PI-->
                            <td class="checkbox">
                                <div *ngIf="item.LaborType !== 'FRL'"></div>
                                <div *ngIf="item.LaborType === 'FRL'">
                                    <p-cellEditor>
                                        <ng-template
                                            *ngIf="!item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <p-checkbox
                                                [disabled]="
                                                    item.IsReadOnly ||
                                                    item.LaborType !== 'FRL'
                                                "
                                                binary="true"
                                                type="checkbox"
                                                [(ngModel)]="item.IsSickPI"
                                            ></p-checkbox>
                                        </ng-template>
                                        <ng-template
                                            *ngIf="item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check': item?.IsSickPI,
                                                    green: item?.IsSickPI
                                                }"
                                            ></i>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check': item?.IsSickPI,
                                                    green: item?.IsSickPI
                                                }"
                                            ></i>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </td>
                            <!-- Holiday PI-->
                            <td class="checkbox">
                                <div *ngIf="item.LaborType !== 'FRL'"></div>
                                <div *ngIf="item.LaborType === 'FRL'">
                                    <p-cellEditor>
                                        <ng-template
                                            *ngIf="!item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <p-checkbox
                                                [disabled]="
                                                    item.IsReadOnly ||
                                                    item.LaborType !== 'FRL'
                                                "
                                                binary="true"
                                                type="checkbox"
                                                [(ngModel)]="item.IsHolidayPI"
                                            ></p-checkbox>
                                        </ng-template>
                                        <ng-template
                                            *ngIf="item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check':
                                                        item?.IsHolidayPI,
                                                    green: item?.IsHolidayPI
                                                }"
                                            ></i>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check':
                                                        item?.IsHolidayPI,
                                                    green: item?.IsHolidayPI
                                                }"
                                            ></i>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </td>
                            <!-- IsActive (QBO only, excludes GovConPay) -->
                            <!-- *ngIf="qbo && !externalIntegration" -->
                            <td
                                *featureFlag="'ffInactivatePayrollItems'"
                                class="checkbox"
                            >
                                <div>
                                    <p-cellEditor>
                                        <ng-template
                                            *ngIf="!item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <p-checkbox
                                                binary="true"
                                                type="checkbox"
                                                [(ngModel)]="item.IsActive"
                                            ></p-checkbox>
                                        </ng-template>
                                        <ng-template
                                            *ngIf="item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check': item?.IsActive !== false,
                                                    green: item?.IsActive !== false
                                                }"
                                            ></i>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check': item?.IsActive !== false,
                                                    green: item?.IsActive !== false
                                                }"
                                            ></i>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </td>
                            <!-- Alt Pay Rate (read-only when external payroll / GCP) -->
                            <td class="checkbox">
                                <div>
                                    <p-cellEditor>
                                        <ng-template
                                            *ngIf="
                                                !item.IsReadOnly &&
                                                isAlternateHourlyEditable()
                                            "
                                            pTemplate="input"
                                        >
                                            <p-checkbox
                                                binary="true"
                                                type="checkbox"
                                                [(ngModel)]="item.IsAlternateHourly"
                                                [disabled]="!isHourlyPayrollItemType(item)"
                                                [pTooltip]="
                                                    !isHourlyPayrollItemType(item)
                                                        ? 'Alt Pay Rate applies only to hourly payroll item types.'
                                                        : ''
                                                "
                                                tooltipPosition="top"
                                                [tooltipDisabled]="
                                                    isHourlyPayrollItemType(item)
                                                "
                                            ></p-checkbox>
                                        </ng-template>
                                        <ng-template
                                            *ngIf="
                                                item.IsReadOnly ||
                                                !isAlternateHourlyEditable()
                                            "
                                            pTemplate="input"
                                        >
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check':
                                                        item?.IsAlternateHourly &&
                                                        isHourlyPayrollItemType(
                                                            item
                                                        ),
                                                    green:
                                                        item?.IsAlternateHourly &&
                                                        isHourlyPayrollItemType(
                                                            item
                                                        )
                                                }"
                                                [pTooltip]="
                                                    !isAlternateHourlyEditable()
                                                        ? 'Alt Pay Rate is controlled by external payroll and cannot be changed.'
                                                        : ''
                                                "
                                                tooltipPosition="top"
                                                [tooltipDisabled]="
                                                    isAlternateHourlyEditable()
                                                "
                                            ></i>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <i
                                                [ngClass]="{
                                                    pi: true,
                                                    'pi-check':
                                                        item?.IsAlternateHourly &&
                                                        isHourlyPayrollItemType(
                                                            item
                                                        ),
                                                    green:
                                                        item?.IsAlternateHourly &&
                                                        isHourlyPayrollItemType(
                                                            item
                                                        )
                                                }"
                                            ></i>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </td>                           
                            <!-- Export Code -->
                            <td
                                *ngIf="qbo"
                                class="checkbox"
                            >
                                <div>
                                    <p-cellEditor>
                                        <ng-template
                                            *ngIf="!item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            <p-select
                                                [style]="{ width: '100%' }"
                                                [virtualScroll]="true"
                                                [itemSize]="dropdownItemHeight"
                                                [options]="
                                                    payCodeSelectItems
                                                        | orderBy: 'label'
                                                "
                                                [autoDisplayFirst]="false"
                                                appendTo="body"
                                                [(ngModel)]="item.ExportCode"
                                                defaultLabel="Export Code"
                                                [filter]="true"
                                            ></p-select>
                                        </ng-template>
                                        <ng-template
                                            *ngIf="item.IsReadOnly"
                                            pTemplate="input"
                                        >
                                            {{
                                                (
                                                    payCodeSelectItems
                                                    | itemlookup
                                                        : 'value'
                                                        : item?.ExportCode
                                                )?.label ?? item?.ExportCode
                                            }}
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{
                                                (
                                                    payCodeSelectItems
                                                    | itemlookup
                                                        : 'value'
                                                        : item?.ExportCode
                                                )?.label ?? item?.ExportCode
                                            }}
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </p-accordionTab>
    <p-accordionTab [selected]="true" header="Employees">
        <div style="max-height: 25vh">
            <p-table stripedRows id="employees"
                #dtEmployees
                [value]="employees"
                dataKey="id"
                [scrollable]="true"
                scrollHeight="25vh"
            >
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>

                <ng-template #header let-item>
                    <tr>
                        <!-- Payroll Item -->
                        <th >
                            Payroll Item
                            <p-sortIcon
                                pSortableColumn="Payrollitem"
                                field="Payrollitem"
                                ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"
                            ></p-sortIcon>
                        </th>
                        <!-- Name -->
                        <th >
                            {{
                                externalIntegration
                                    ? 'Employee Assigned in GovConPay'
                                    : 'Employee Assigned in QuickBooks'
                            }}
                            <p-sortIcon
                                pSortableColumn="Employeename"
                                field="Employeename"
                                ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"
                            ></p-sortIcon>
                            <p-columnFilter field="Employeelistid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect
                                        defaultLabel="Filter"
                                        maxSelectedLabels="1"
                                        appendTo="body"
                                        [options]="employeesSelectItems"
                                        [filter]="true"
                                        styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                                    ></p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>
                        <!-- Auth End Date -->
                        <th >
                            Authorized in eFAACT Thru
                            <p-sortIcon
                                pSortableColumn="Maxauthenddate"
                                field="Maxauthenddate"
                                ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"
                            ></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template #body let-item>
                    <tr
                        data-id="row-{{ item.PIListID }}"
                    >
                        <!-- Payroll Item-->
                        <td class="disabled">
                            {{ item?.Payrollitem }}
                        </td>
                        <!-- Name -->
                        <td class="disabled">
                            {{ item?.Employeename }}
                        </td>
                        <!-- Auth End Date -->
                        <td class="disabled">
                            {{ item?.Maxauthenddate }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-accordionTab>
</p-accordion>
